import classNames from "classnames";
import * as React from "react";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { Pager } from "../../../../../../react-core/Html/Pager";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { ThreadType } from "../../../../../../Wrap/Constants/Enums/Domain/ThreadType";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { ThreadResponse } from "../../../../../../Wrap/Models/Domains/Threads/ThreadResponse";
import { ContentTable } from "../../../../../Admin/Network/Resource/Content";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { TableHeader } from "../../../../../Shared/Table/Components/TableHeader";
import { TableRow } from "../../../../../Shared/Table/Components/TableRow";
import { ScrollTable } from "../../../../../Shared/Table/ScrollTable";
import { IPaginationCofig, ICombineTableConfig, ITableState, ITableConfig } from "../../../../../Shared/Table/Table";
import { TableColSettingsAction } from "../../../../../Shared/TableColFilter/Action/Action";
import { defaultTableColEditor } from "../../../../../Shared/TableColFilter/Resource/Content";
import { TableColSettingsStore } from "../../../../../Shared/TableColFilter/Store/Variable";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../Urls";
import { EventTypeMap } from "../../Resource/Content";

interface INotificationTableProps extends React.Props<NotificationTable> {
    cssWrapper?: string;
    onRef?: (ref) => void;
    noDefaultCssWrapper?: boolean;
    tHeadCssWrapper?: string;
    rowCssWrapper?: string;
    isLoading?: boolean;
    needPagination?: IPaginationCofig;
    isScrollable?: boolean;
    isExpanedCondition?: (row, index) => boolean;
    SubTitle?: string;
    SubBody?: ICombineTableConfig[];
    TotalBody?: ICombineTableConfig[];
    data: any[];
    colEditorKey?: string;
    showEmptyMsg?: boolean;
    cssEmptyMessage?: string;
    emptyMsg?: string;
    dragOption?: {
        dragable: boolean;
        onReorder: (result: any[]) => void;
        dragIconPosition?: "right" | "left";
        dragTitle?: string;
    };
    updateRow?: (row) => void;
}

interface INotificationTableState extends ITableState {
    showMandatoryNotificationPopup: boolean;
    selectedMandatoryNotification: any;
}

interface INotificationTableConfig extends ITableConfig {}

export class NotificationTable extends FormComponent<INotificationTableProps, INotificationTableState> {
    constructor(props: INotificationTableProps) {
        super(props);
        this.state = {
            currentColSettings: null,
            pageSize: props.needPagination?.pageSize,
            showMandatoryNotificationPopup: false,
            selectedMandatoryNotification: null,
        };
        this.subscribeToStore(TableColSettingsStore, () => this.onTableColSettingsStoreChange());
    }

    componentDidMount() {
        this.getSettings();
        this.props.onRef ? this.props.onRef(this) : null;
    }

    private onTableColSettingsStoreChange() {
        this.getSettings();
    }

    private getSettings() {
        const { colEditorKey } = this.props;
        if (!colEditorKey) {return;}
        const _settings = JSON.parse(JSON.stringify(TableColSettingsStore.getData()));
        if (!_settings) {
            TableColSettingsAction.get(colEditorKey);
        } else if (JSON.stringify(_settings) == "{}") {
            TableColSettingsAction.post(defaultTableColEditor);
        } else if (!_settings[colEditorKey]) {
            TableColSettingsAction.post(defaultTableColEditor[colEditorKey], colEditorKey);
        } else {
            this.setState({ currentColSettings: _settings[colEditorKey] });
        }
    }

    private PAGESIZE = 10;

    private DRAGICONPOSITION = "right";

    private DRAGTITLE = "Reorder";

    private renderReorderIcon = () => {
        return (
            <button className="reorder-button">
                <span className="sr-only">Reorder</span>
                <span className="icon" aria-hidden="true"></span>
            </button>
        );
    };

    private getList = () => document.getElementById("drag-sort-table-draggable");

    private move = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();

        const list = e.currentTarget.parentNode,
            x = e.clientX,
            y = e.clientY;

        const swapItem = document.elementFromPoint(x, y) === null ? e.currentTarget : document.elementFromPoint(x, y);

        if (list === swapItem.parentNode) {
            const _swapItem = swapItem !== e.currentTarget.nextSibling ? swapItem : swapItem.nextSibling;
            list.insertBefore(e.currentTarget, _swapItem);
        }
        if (list.contains(swapItem) && list !== swapItem) {
            const dragItem = this.getDragItemByTarget(swapItem, list);
            const _swapItem = dragItem && dragItem !== e.currentTarget.nextSibling ? dragItem : swapItem.nextSibling;
            list.insertBefore(e.currentTarget, _swapItem);
        }
    };

    private getDragItemByTarget = (target: Element, pNode: Node) => {
        let _dragItem = null;
        pNode.childNodes.forEach((item) => {
            if (item.contains(target)) {
                _dragItem = item;
            }
        });
        return _dragItem;
    };

    private drop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        (e.currentTarget.childNodes[0] as HTMLElement).style.opacity = "1";
        const _list = this.getList();
        const result = [];
        _list.childNodes.forEach((element) => {
            const index: string = (element as HTMLElement).id;
            result.push(this.props.data[index]);
        });

        this.props.dragOption.onReorder(result);
    };

    private renderBody(data: any[], col: INotificationTableConfig[]) {
        const { showEmptyMsg, emptyMsg, cssEmptyMessage, dragOption } = this.props;
        if (showEmptyMsg && data && data.length == 0) {
            return (
                <tbody>
                    <tr>
                        <td colSpan={col.length}>
                            {" "}
                            <div className={cssEmptyMessage}>{emptyMsg ? emptyMsg : ContentTable.noDataMsg}</div>
                        </td>
                    </tr>
                </tbody>
            );
        }

        if (!data || !col) {return null;}
        const rows = [];

        if (dragOption && dragOption.dragable) {
            const postion = dragOption.dragIconPosition || this.DRAGICONPOSITION;
            const reorderCol: INotificationTableConfig = {
                title: dragOption.dragTitle || this.DRAGTITLE,
                key: "",
                render: () => {
                    return this.renderReorderIcon();
                },
            };
            if (postion == "left") {
                col = [reorderCol].concat(col);
            } else {
                col.push(reorderCol);
            }
        }
        data.forEach((ele, index) => {
            rows.push(
                <TableRow
                    data={ele}
                    col={col}
                    index={index}
                    key={`row-${index}`}
                    draggable={dragOption && dragOption.dragable}
                    rowCssWrapper={this.props.rowCssWrapper}
                    onMove={(e) => this.move(e)}
                    onDrop={(e) => this.drop(e)}
                />
            );
        });

        return (
            <tbody id={`drag-sort-table${dragOption ? "-draggable" : ""}`}>
                {this.props.SubTitle && (
                    <tr className="sub-head">
                        <td colSpan={col.length}>{this.props.SubTitle}</td>
                    </tr>
                )}
                {rows}
            </tbody>
        );
    }

    private renderSubBody(type: "sub" | "total", config: ICombineTableConfig[]) {
        if (!config) {return null;}
        const { currentColSettings } = this.state;
        let lastColSpan = 0;
        return (
            <tfoot>
                <tr className={type == "sub" ? "sub-total" : "total"}>
                    {config.map((ele, index) => {
                        let disabledColumns = 0;
                        let colSpan = ele.colSpan ? ele.colSpan : 1;
                        if (currentColSettings != null && ele.colIndex != null && ele.colIndex > 0) {
                            if (
                                ele.colIndex >= currentColSettings.length ||
                                currentColSettings[ele.colIndex].Enabled == false
                            ) {
                                //if this column is removed, don't render this total
                                return null;
                            }
                            const columnsBefore = currentColSettings.slice(0, ele.colIndex);
                            disabledColumns = columnsBefore.filter((ele) => ele.Enabled == false).length;
                            colSpan = ele.colIndex - disabledColumns - lastColSpan;
                            lastColSpan = ele.colIndex - disabledColumns;
                        }

                        return (
                            <td
                                key={`sub-${index}`}
                                colSpan={colSpan}
                                className={index == 0 ? null : ele.tfTdCssWrapper}
                            >
                                {ele.data}
                            </td>
                        );
                    })}
                </tr>
            </tfoot>
        );
    }

    private renderPartLoading() {
        return <PartLoading isLoading={true} />;
    }

    private renderPagination() {
        const { totalNumOfResult, onPaginationChange, currentPage, isShowPerPageOptions } = this.props.needPagination;
        const { pageSize } = this.state;
        const _pageSize = pageSize || this.PAGESIZE;
        const _isShowPerPageOptions = CommonHelper.isNullOrEmpty(isShowPerPageOptions) ? false : isShowPerPageOptions;
        return (
            <Pager
                pager={{
                    CurrentPage: currentPage,
                    ResultsPerPage: _pageSize,
                    TotalPages: Math.ceil(totalNumOfResult / _pageSize),
                    TotalRecords: totalNumOfResult,
                }}
                onChange={(recordsPerPage: number, pageIndex: number) => {
                    this.setState({ pageSize: recordsPerPage });
                    onPaginationChange(pageIndex, recordsPerPage);
                }}
                recordsPerPageOptions={[20, 50, 100]}
                isShowPerPageOptions={_isShowPerPageOptions}
            />
        );
    }

    private getColumn(settings: any[], col: INotificationTableConfig[]) {
        const result = [];
        settings.forEach((ele) => {
            if (ele.Enabled) {
                const findObj = col.find((item) => item.tableFilter == ele.Column);
                if (findObj) {result.push(col.find((item) => item.tableFilter == ele.Column));}
            }
        });
        return result;
    }

    private renderTContent(data, col) {
        return (
            <>
                <TableHeader col={col} cssWrapper={this.props.tHeadCssWrapper} />
                {this.renderBody(data, col)}
                {this.renderSubBody("sub", this.props.SubBody)}
                {this.renderSubBody("total", this.props.TotalBody)}
            </>
        );
    }

    private getColumnHeaders(): ITableConfig[] {
        return [
            {
                title: "Toggle to expand details for this row",
                thInnerCss: "sr-only",
                key: "",
                render: (data, row: any) => {
                    return (
                        <div className="row narrow-gutter no-wrap">
                            <div className="col-auto">
                                <button className="te-expand-btn" aria-expanded={false} onClick={() => {}}>
                                    <span className="sr-only">Click to expand details for this row</span>
                                </button>
                            </div>
                        </div>
                    );
                },
                toogleOptions: (row) => {
                    return {
                        toogleable: true,
                        isToogle: row.isToogle,
                        onToogle: (isToogle) => {
                            if (row?.Type == ThreadType.Alert && isToogle == true) {
                                this.setState({
                                    showMandatoryNotificationPopup: true,
                                    selectedMandatoryNotification: row,
                                });
                            } else {
                                console.log(isToogle);
                                row.IsRead = isToogle;
                                this.props.updateRow(row);
                            }
                        },
                        expandContent: (
                            <div className="ml-20">
                                <span dangerouslySetInnerHTML={{ __html: row?.Message.replace(/[\\]/g, "") }} />
                            </div>
                        ),
                    };
                },
            },
            {
                title: "Type",
                key: "Type",
                render: (data) => {
                    return EventTypeMap[data];
                },
            },
            {
                title: "Notification",
                key: "EventType",
            },
            {
                title: "Account number",
                key: "AccountNumber",
            },
            {
                title: "Client name",
                key: "ClientName",
                render: (data, row: any) => {
                    return checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView) ? (
                        <a
                            className="hyperlink"
                            onClick={() =>
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                            HierarchyLevelName.Customer,
                                            row?.CustomerId
                                        ),
                                    }).detail
                                )
                            }
                        >
                            {row.ClientName}
                        </a>
                    ) : null;
                },
            },
            {
                title: "Adviser",
                key: "AdviserName",
            },
            {
                title: "Date",
                key: "LastMessageOn",
                render: (data, row: any) => {
                    return (
                        <div className="row narrow-gutter no-wrap">
                            {JsonDateParser.getFormatDate(data, "dd/MM/yyyy")}
                        </div>
                    );
                },
            },
            {
                title: "Flag for follow up",
                key: "",
                tdCssWrapper: "text-center",
                render: (data, row: any) => {
                    return (
                        <button
                            className="follow-up-button mb-26"
                            onClick={(v) => {
                                row.IsFollowed = !row.IsFollowed;
                                this.props.updateRow(row);
                            }}
                        >
                            <span className="icon" aria-hidden={true} aria-pressed={row?.IsFollowed}></span>
                            <span className="text sr-only">Follow up</span>
                        </button>
                    );
                },
            },
            {
                title: this.checkAll(),
                key: "",
                thCssWrapper: "text-center",
                tdCssWrapper: "text-center",
                render: (data, row: ThreadResponse) => {
                    return (
                        <CheckboxEditor
                            value={row?.IsRead}
                            onChange={(v) => {
                                if (row?.Type == ThreadType.Alert && v) {
                                    this.setState({
                                        showMandatoryNotificationPopup: true,
                                        selectedMandatoryNotification: row,
                                    });
                                } else {
                                    row.IsRead = v;
                                    this.props.updateRow(row);
                                }
                            }}
                            label="Mark as read"
                            cssWrapper="square-checkbox mb-0 label-sr-only"
                        />
                    );
                },
            },
        ];
    }

    private checkAll() {
        const { data } = this.props;
        return (
            <div>
                <CheckboxEditor
                    value={data.every((x) => x.IsRead)}
                    cssWrapper={"square-checkbox mb-0"}
                    label="Mark as read"
                    onChange={(v) => {
                        data.forEach((ele, index) => {
                            ele.IsRead = v;
                            this.props.updateRow(ele);
                        });
                    }}
                />
            </div>
        );
    }

    public render(): JSX.Element {
        const { data, needPagination, isLoading, colEditorKey, isScrollable, noDefaultCssWrapper } = this.props;
        const col = this.getColumnHeaders();
        const { currentColSettings, showMandatoryNotificationPopup, selectedMandatoryNotification } = this.state;
        const _isSrollable = isScrollable != undefined ? isScrollable : true;
        if (isLoading == true || (colEditorKey && !currentColSettings)) {return this.renderPartLoading();}
        let _col = col.filter((ele) => ele !== null);
        _col = _col.filter((ele) => (ele.userClaim ? checkPermission(ele.userClaim) : true));
        _col = colEditorKey ? this.getColumn(currentColSettings, _col) : _col;
        const isRenderPagination = data && needPagination && needPagination.totalNumOfResult > 0;
        const cssWrapper = noDefaultCssWrapper
            ? this.props.cssWrapper
            : classNames("data-table", this.props.cssWrapper);
        return (
            <>
                {_isSrollable ? (
                    <ScrollTable cssWrapper={this.props.cssWrapper}>{this.renderTContent(data, _col)}</ScrollTable>
                ) : (
                    <table className={cssWrapper}>{this.renderTContent(data, _col)}</table>
                )}
                {isRenderPagination && this.renderPagination()}
                {showMandatoryNotificationPopup && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showMandatoryNotificationPopup}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showMandatoryNotificationPopup: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">
                            Please confirm this action. Action required notifications contain information which should
                            be reviewed. You can find historic Action required notifications again using the
                            Notification Filter functionality.
                        </p>
                        <div className="row">
                            <button
                                className="btn primary mt-20 mr-5"
                                onClick={() => {
                                    this.setState({ showMandatoryNotificationPopup: false });
                                    selectedMandatoryNotification.IsRead = true;
                                    this.props.updateRow(selectedMandatoryNotification);
                                }}
                            >
                                Yes, mark as read
                            </button>
                            <button
                                className="btn secondary mt-20"
                                onClick={() => {
                                    this.setState({ showMandatoryNotificationPopup: false });
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </Lightbox>
                )}
            </>
        );
    }
}
